import { type FC, memo, type ReactNode } from 'react'

import { ChatFileChip } from './chat-file-chip.atom'
import type { ChatMessageAttachment } from './chat-message.interface'

export interface ChatMessageAttachmentChipProps {
  attachment: ChatMessageAttachment

  onDownload?: (attachmentId: string) => void

  className?: string
}

const ChatMessageAttachmentChipBase: FC<ChatMessageAttachmentChipProps> = ({
  attachment,
  onDownload,
  className,
}): ReactNode => (
  <ChatFileChip
    filename={attachment.filename}
    mimeType={attachment.mimeType}
    sizeBytes={attachment.sizeBytes}
    semanticClass="chat-message-attachment-chip"
    className={className}
    onClick={onDownload ? () => onDownload(attachment.id) : undefined}
  />
)

export const ChatMessageAttachmentChip = memo(ChatMessageAttachmentChipBase)

ChatMessageAttachmentChip.displayName = 'ChatMessageAttachmentChip'
